import {AmsListItemBase} from './AmsListItemBase';
import * as XCol from '../../framework.core/XExportColumn';

export class Ams1CHistoryListItem extends AmsListItemBase {
    date: string = '';
    toDate: string | null = null;
    fromDate: string | null = null;
    hblNo: string = '';
    entryNo: string = '';
    containerNo: string = '';
    pkg: number|null = null;
    toPkg: number|null = null;
    fromPkg: number|null = null;
    amsGroupId: number|null = null;
    branch: string = '';
    id: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 2, text: 'HBL #', width: 100, dataIndex: 'hblNo', defaultColumnFocus : true}),
        XCol.Create({ col: 3, text: 'Entry #', width: 100, dataIndex: 'entryNo'}),
        XCol.Create({ col: 4, text: 'Container #', width: 90, dataIndex: 'containerNo'}),
        XCol.Create({ col: 5, text: 'Qty', width: 60, dataIndex: 'pkg', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, noNullOrEmptySearch: true }),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: Ams1CHistoryListItem.prototype.id, orderByAscending: false };

    public static formatData(data: Ams1CHistoryListItem[]) {
        return data.map((d: Ams1CHistoryListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        date: {from: 'fromDate', to: 'toDate'},
        pkg: {from: 'toPkg', to: 'fromPkg'},
    }
}
